(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["2025-holiday-variety-lander-main"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
      // Mobile image carousel
      const carouselRoot = document.querySelector('.image-carousel-wrapper');
      if (!carouselRoot) return;

      const viewport = carouselRoot.querySelector('.lp_image_carousel_embla__viewport');
      EmblaCarousel(viewport, {
        dragFree: true,
        loop: true
      });

    // --- Interactive Large Image Rotator Only ---
      const lgImg = document.querySelector('.img-wrapper-lg img');
      const nextBtn = document.querySelector('.img-lg-container .lp-main-next-btn');
      const prevBtn = document.querySelector('.img-lg-container .lp-main-prev-btn');

      if (lgImg) {
        // Get all image sources from the DOM
        allSources = [
          lgImg.src,
          ...Array.from(document.querySelectorAll('.img-wrapper-sm img')).map(img => img.src)
        ];

        let currentIndex = 0;

        const updateLgImage = () => {
          lgImg.src = allSources[currentIndex];
        };

        const rotateForward = () => {
          currentIndex = (currentIndex + 1) % allSources.length;
          updateLgImage();
        };

        const rotateBackward = () => {
          currentIndex = (currentIndex - 1 + allSources.length) % allSources.length;
          updateLgImage();
        };

        lgImg.addEventListener('click', rotateForward);
        if (nextBtn) nextBtn.addEventListener('click', rotateForward);
        if (prevBtn) prevBtn.addEventListener('click', rotateBackward);
      }

      // FAQ toggle
      document.querySelectorAll('.faq-question').forEach((question) => {
        question.addEventListener('click', () => {
          question.classList.toggle('open');
        });
      });

    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["2025-landing-page_heading-product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
      // Mobile image carousel
      const carouselRoot = document.querySelector('.image-carousel-wrapper');
      if (!carouselRoot) return;

      const viewport = carouselRoot.querySelector('.lp_image_carousel_embla__viewport');
      EmblaCarousel(viewport, {
        dragFree: true,
        loop: true
      });

    // --- Interactive Large Image Rotator Only ---
      const lgImg = document.querySelector('.img-wrapper-lg img');
      const nextBtn = document.querySelector('.img-lg-container .lp-main-next-btn');
      const prevBtn = document.querySelector('.img-lg-container .lp-main-prev-btn');

      if (lgImg) {
        // Get all image sources from the DOM
        allSources = [
          lgImg.src,
          ...Array.from(document.querySelectorAll('.img-wrapper-sm img')).map(img => img.src)
        ];

        let currentIndex = 0;

        const updateLgImage = () => {
          lgImg.src = allSources[currentIndex];
        };

        const rotateForward = () => {
          currentIndex = (currentIndex + 1) % allSources.length;
          updateLgImage();
        };

        const rotateBackward = () => {
          currentIndex = (currentIndex - 1 + allSources.length) % allSources.length;
          updateLgImage();
        };

        lgImg.addEventListener('click', rotateForward);
        if (nextBtn) nextBtn.addEventListener('click', rotateForward);
        if (prevBtn) prevBtn.addEventListener('click', rotateBackward);
      }

      // FAQ toggle
      document.querySelectorAll('.faq-question').forEach((question) => {
        question.addEventListener('click', () => {
          question.classList.toggle('open');
        });
      });

      // Make entire container clickable
      document.querySelectorAll('.buy-option-container, .buy-option-container-lg-product').forEach((container) => {
        container.addEventListener('click', () => {
          const input = container.querySelector('input[type="radio"]');
          if (input) {
            input.checked = true;
            input.dispatchEvent(new Event('change'));
          }
        });
      });

      document.querySelector('.buy-option-container-lg-footer')?.addEventListener('click', () => {
        const radio = document.querySelector('.buy-option-container-lg-product input[type="radio"]');
        if (radio) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change')); // Trigger change event if needed
        }
      
        // Remove "selected" from all .buy-option-container elements
        document.querySelectorAll('.buy-option-container.selected').forEach((el) => {
          el.classList.remove('selected');
        });
      
        // Add "selected" to .buy-option-container-lg
        document.querySelector('.buy-option-container-lg')?.classList.add('selected');
      });


      //Handle selected visual state
      document.querySelectorAll('input[type="radio"][name="id"]').forEach((input) => {
        input.addEventListener('change', () => {
          document.querySelectorAll('.buy-option-container, .buy-option-container-lg-product').forEach((el) => {
            el.classList.remove('selected');
          });
          const container = input.closest('.buy-option-container') || input.closest('.buy-option-container-lg-product');
          if (container) {
            container.classList.add('selected');
          }
        });
      });

      // for borders
    document.querySelectorAll('.buy-option-container, .buy-option-container-lg-product').forEach((container) => {
  container.addEventListener('click', () => {
    // Remove 'selected' from all containers that actually have borders
    document.querySelectorAll('.buy-option-container, .buy-option-container-lg').forEach((el) => {
      el.classList.remove('selected');
    });

    // Add 'selected' to the correct outer container
    const outer = container.closest('.buy-option-container') || container.closest('.buy-option-container-lg');
    if (outer) {
      outer.classList.add('selected');
    }
  });
});
    

    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["2025-landing-page_info"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const carouselRoot = document.querySelector('.landing-page_info_carousel');
    if (!carouselRoot) return;

    const viewport = carouselRoot.querySelector('.info_carousel_embla__viewport');
    EmblaCarousel(viewport, {
      loop: true,
      dragFree: true
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["2025-landing-page_nutrition"] && !Shopify.designMode) return;
  try {
    
 
  document.addEventListener('DOMContentLoaded', () => {
    const emblaRoot = document.querySelector('.nutrition-cards-carousel');
    if (!emblaRoot) return;

    const viewport = emblaRoot.querySelector('.embla__viewport');
    EmblaCarousel(viewport, {
      dragFree: true,
      loop: true
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["2025-landing-page_reviews"] && !Shopify.designMode) return;
  try {
    
 document.addEventListener('DOMContentLoaded', () => {
  const carousels = [
    {
      rootSelector: '.check-out-each-flavor',
      viewportSelector: '.embla__viewport'
    },
    {
      rootSelector: '.craftmix-lovers',
      viewportSelector: '.embla__viewport'
    }
  ];

  carousels.forEach(({ rootSelector, viewportSelector }) => {
    const root = document.querySelector(rootSelector);
    if (!root) return;

    const viewport = root.querySelector(viewportSelector);
    if (!viewport) return;

    EmblaCarousel(viewport, {
      dragFree: true,
      loop: true
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["2025-main-blog"] && !Shopify.designMode) return;
  try {
    
 
 document.addEventListener("DOMContentLoaded", function () {
  const loadMoreBtn = document.getElementById("load-more-btn");
  const blogGrid = document.querySelector(".blog-main-grid");

  if (!loadMoreBtn) {
    console.error("❌ Load More button not found.");
    return;
  }

  console.log("✅ Load More button detected.");

  loadMoreBtn.addEventListener("click", function (event) {
    event.preventDefault(); // Prevent default link behavior
    console.log("📌 Load More button clicked.");

    let currentPage = parseInt(loadMoreBtn.getAttribute("data-current-page"));
    let totalPages = parseInt(loadMoreBtn.getAttribute("data-total-pages"));
    let blogHandle = loadMoreBtn.getAttribute("data-blog-handle");
    let nextPage = currentPage + 1;

    console.log(`🔄 Current Page: ${currentPage}, Next Page: ${nextPage}, Total Pages: ${totalPages}`);

    if (nextPage > totalPages) {
      // console.log("✅ All pages loaded. Hiding button.");
      loadMoreBtn.style.display = "none";
      return;
    }

    let fetchUrl = `/blogs/${blogHandle}?page=${nextPage}`;
    // console.log(`🔗 Fetching: ${fetchUrl}`);

    fetch(fetchUrl)
      .then(response => response.text())
      .then(data => {
        // console.log("✅ Data received from server.");
        let parser = new DOMParser();
        let newDocument = parser.parseFromString(data, "text/html");
        let newArticles = newDocument.querySelectorAll(".custom-blog-article-card");

        if (newArticles.length === 0) {
          console.warn("⚠️ No new articles found.");
          return;
        }

        console.log(`✅ Found ${newArticles.length} new articles. Appending to page.`);
        newArticles.forEach(article => {
          blogGrid.appendChild(article);
        });

        // Update the button to the next page
        loadMoreBtn.setAttribute("data-current-page", nextPage);

        // Hide button if it's the last page
        if (nextPage >= totalPages) {
          // console.log("✅ Last page reached. Hiding button.");
          loadMoreBtn.style.display = "none";
        }
      })
      .catch(error => console.error("❌ Error loading more articles:", error));
  });
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["2025-variety-lander-main"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
      // Mobile image carousel
      const carouselRoot = document.querySelector('.image-carousel-wrapper');
      if (!carouselRoot) return;

      const viewport = carouselRoot.querySelector('.lp_image_carousel_embla__viewport');
      EmblaCarousel(viewport, {
        dragFree: true,
        loop: true
      });

    // --- Interactive Large Image Rotator Only ---
      const lgImg = document.querySelector('.img-wrapper-lg img');
      const nextBtn = document.querySelector('.img-lg-container .lp-main-next-btn');
      const prevBtn = document.querySelector('.img-lg-container .lp-main-prev-btn');

      if (lgImg) {
        // Get all image sources from the DOM
        allSources = [
          lgImg.src,
          ...Array.from(document.querySelectorAll('.img-wrapper-sm img')).map(img => img.src)
        ];

        let currentIndex = 0;

        const updateLgImage = () => {
          lgImg.src = allSources[currentIndex];
        };

        const rotateForward = () => {
          currentIndex = (currentIndex + 1) % allSources.length;
          updateLgImage();
        };

        const rotateBackward = () => {
          currentIndex = (currentIndex - 1 + allSources.length) % allSources.length;
          updateLgImage();
        };

        lgImg.addEventListener('click', rotateForward);
        if (nextBtn) nextBtn.addEventListener('click', rotateForward);
        if (prevBtn) prevBtn.addEventListener('click', rotateBackward);
      }

      // FAQ toggle
      document.querySelectorAll('.faq-question').forEach((question) => {
        question.addEventListener('click', () => {
          question.classList.toggle('open');
        });
      });

    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["2025-variety-lander-nutrition"] && !Shopify.designMode) return;
  try {
    
 
  document.addEventListener('DOMContentLoaded', () => {
    const emblaRoot = document.querySelector('.nutrition-cards-carousel');
    if (!emblaRoot) return;

    const viewport = emblaRoot.querySelector('.embla__viewport');
    EmblaCarousel(viewport, {
      dragFree: true,
      loop: true
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["2025-variety-lander-reviews"] && !Shopify.designMode) return;
  try {
    
 document.addEventListener('DOMContentLoaded', () => {
  const carousels = [
    {
      rootSelector: '.check-out-each-flavor',
      viewportSelector: '.embla__viewport'
    },
    {
      rootSelector: '.craftmix-lovers',
      viewportSelector: '.embla__viewport'
    }
  ];

  carousels.forEach(({ rootSelector, viewportSelector }) => {
    const root = document.querySelector(rootSelector);
    if (!root) return;

    const viewport = root.querySelector(viewportSelector);
    if (!viewport) return;

    EmblaCarousel(viewport, {
      dragFree: true,
      loop: true
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Custom-flavor-carousel"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function() {
  const addToCartButtons = document.querySelectorAll('.product-card-add-btn');
  const variantSelects = document.querySelectorAll('select[name="product-variant-size"]');

  addToCartButtons.forEach(button => {
    button.addEventListener('click', function(event) {
      event.preventDefault();
      const productId = this.getAttribute('data-product-id');
      const variantSelect = document.getElementById(`product-variant-size-${productId}`);
      const variantId = variantSelect.value;
      const quantity = 1;

      addToCart(variantId, quantity);
    });
  });

  variantSelects.forEach(select => {
    select.addEventListener('change', function() {
      const productId = this.id.split('-').pop();
      const selectedVariant = this.options[this.selectedIndex];
      const variantPrice = selectedVariant.getAttribute('data-price');
      const priceElement = this.closest('.product-card').querySelector('.variant-price');
      
      if (priceElement && variantPrice) {
        priceElement.textContent = formatMoney(variantPrice);
      }
    });
  });

  function addToCart(variantId, quantity) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: [{
          id: variantId,
          quantity: quantity
        }]
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log('Product added to cart:', data);
     
    })
    .catch(error => {
      console.error('Error adding product to cart:', error);
      
    });
  }

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
    });
  }
});

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-flavor-carousel"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const addToCartButtons = document.querySelectorAll('.flavor-carousel-product-card-add-btn');

  // Toggle dropdown logic
  document.querySelectorAll('.custom-variant-trigger').forEach(trigger => {
    const dropdownId = trigger.getAttribute('data-dropdown-id');
    const dropdown = document.getElementById(dropdownId);
    const selectedText = trigger.querySelector('.selected-variant');

    if (!dropdown || !selectedText) return;

    trigger.addEventListener('click', (e) => {
      e.stopPropagation();

      // Hide any other open dropdowns
      document.querySelectorAll('.variant-options-container').forEach(d => {
        if (d !== dropdown) {
          d.style.display = 'none';
        }
      });

      // Show this dropdown
      dropdown.style.display = dropdown.style.display === 'block' ? 'none' : 'block';
    });

    // Variant selection inside dropdown
    dropdown.querySelectorAll('.variant-option').forEach(option => {
      option.addEventListener('click', () => {
        const variantId = option.dataset.id;
        const variantPrice = option.dataset.price;
        const title = option.textContent;

        selectedText.textContent = title;
        dropdown.style.display = 'none';

        const productCard = trigger.closest('.flavor-carousel-product-card');
        const addBtn = productCard.querySelector('.flavor-carousel-product-card-add-btn');
        const priceEl = productCard.querySelector('.flavor-carousel-variant-price');

        if (addBtn) addBtn.setAttribute('data-product-id', variantId);
        if (priceEl){priceEl.textContent = formatMoney(variantPrice); priceEl.setAttribute('data-product-id', variantId); } 
      });
    });
  });

  // Close dropdown if clicked outside
  document.addEventListener('click', () => {
    document.querySelectorAll('.variant-options-container').forEach(dropdown => {
      dropdown.style.display = 'none';
    });
  });

  // Add to cart functionality
  addToCartButtons.forEach(button => {
    button.addEventListener('click', function(event) {
      event.preventDefault();
      const variantId = this.getAttribute('data-product-id');
      const quantity = 1;

      addToCart(variantId, quantity);
    });
  });

  function addToCart(variantId, quantity) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
    })
    .then(response => response.json())
    .then(data => {
      console.log('Product added to cart:', data);
    })
    .catch(error => {
      console.error('Error adding product to cart:', error);
    });
  }

  function formatMoney(cents) {
    const dollars = (cents / 100).toFixed(2);
    return `$${dollars}`;
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-about-faq"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
            console.log('DOMContentLoaded event fired');
            const faqs = document.querySelectorAll('.faq');
            
            faqs.forEach(faq => {
                faq.addEventListener('click', () => {
                    console.log('FAQ clicked');
                    // Close all other FAQs
                    faqs.forEach(item => {
                        if (item !== faq && item.classList.contains('active')) {
                            item.classList.remove('active');
                        }
                    });
                    
                    // Toggle the clicked FAQ
                    faq.classList.toggle('active');
                });
            });
        });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-about-info"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const video = document.getElementById("about-video");
  const playIcon = document.getElementById("play-icon");
  const volumeIcon = document.getElementById("volume-icon");
  const muteIcon = document.getElementById("mute-icon");
  const videoWrapper = document.getElementById("video-wrapper");
  const volumeToggle = document.getElementById("volume-toggle");

  // Helper: toggle play/pause state
  function togglePlayPause() {
    if (video.paused) {
      video.play();
      playIcon.style.display = "none";
    } else {
      video.pause();
      playIcon.style.display = "inline";
    }
  }

  // Handle video click: anywhere except volume button
  videoWrapper.addEventListener("click", function (e) {
    if (!volumeToggle.contains(e.target)) {
      togglePlayPause();
    }
  });

  // Handle volume toggle
  volumeToggle.addEventListener("click", function () {
    video.muted = !video.muted;
    volumeIcon.style.display = video.muted ? "none" : "inline";
    muteIcon.style.display = video.muted ? "inline" : "none";
  });

  // Pause when out of view
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          video.pause();
          playIcon.style.display = "inline";
        }
      });
    },
    { threshold: 0.2 }
  );

  observer.observe(video);
});
 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-faq-filters"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(".custom-faq-filter");

  buttons.forEach((button) => {
    button.addEventListener("click", function () {
      const category = this.getAttribute("data-category");
      const targetSection = document.getElementById(category);

      // Set active button state
      buttons.forEach(btn => btn.classList.remove("active"));
      this.classList.add("active");

      // Scroll smoothly to the section
      if (targetSection) {
        targetSection.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product-faq"] && !Shopify.designMode) return;
  try {
    

// document.addEventListener('DOMContentLoaded', function () {
//   const faqs = document.querySelectorAll('.faq');

//   faqs.forEach(faq => {
//     const question = faq.querySelector('.question');
//     const answer = faq.querySelector('.answer');

//     question.addEventListener('click', () => {
     
//       faqs.forEach(otherFaq => {
//         const otherAnswer = otherFaq.querySelector('.answer');
//         if (otherFaq !== faq) {
//           otherFaq.classList.remove('faq-active');
//           if (otherAnswer) otherAnswer.style.maxHeight = null;
//         }
//       });

      
//       faq.classList.toggle('faq-active');

//       if (faq.classList.contains('faq-active')) {
//         answer.style.maxHeight = answer.scrollHeight + "px";
//       } else {
//         answer.style.maxHeight = null;
//       }
//     });
//   });
// });

document.addEventListener('DOMContentLoaded', function () {
  const faqs = document.querySelectorAll('.faq');
  const section = document.querySelector('.custom-product-faq-section');
  const faqBody = document.querySelector('.product-faq-body');

  function updateSectionHeight() {
    if (section && faqBody) {
      const faqHeight = faqBody.offsetHeight;
      section.style.height = faqHeight + 'px';
    }
  }

  faqs.forEach(faq => {
    const question = faq.querySelector('.question');
    const answer = faq.querySelector('.answer');

    question.addEventListener('click', () => {
      // Close all other open FAQs first
      faqs.forEach(otherFaq => {
        const otherAnswer = otherFaq.querySelector('.answer');
        if (otherFaq !== faq) {
          otherFaq.classList.remove('faq-active');
          if (otherAnswer) otherAnswer.style.maxHeight = null;
        }
      });

      // Toggle current FAQ
      faq.classList.toggle('faq-active');

      if (faq.classList.contains('faq-active')) {
        answer.style.maxHeight = answer.scrollHeight + "px";
      } else {
        answer.style.maxHeight = null;
      }

      // Delay height update to allow for smooth transition
      setTimeout(updateSectionHeight, 300);
    });
  });

  // Initial height set on load
  updateSectionHeight();
});


 
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product-section"] && !Shopify.designMode) return;
  try {
    


//Flavor card product slide
document.addEventListener('DOMContentLoaded', function () {
  const slider = document.querySelector('.change-flavor-body');
  let isDown = false;
  let startX;
  let scrollLeft;
  let isDragging = false;

  slider.addEventListener('mousedown', (e) => {
    isDown = true;
    slider.style.cursor = 'grabbing';
    startX = e.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
  });

  slider.addEventListener('mouseleave', () => {
    isDown = false;
    slider.style.cursor = 'grab';
  });

  slider.addEventListener('mouseup', () => {
    isDown = false;
    slider.style.cursor = 'grab';
  });

  slider.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - slider.offsetLeft;
    const walk = (x - startX) * 2; // Scroll speed
    slider.scrollLeft = scrollLeft - walk;
    isDragging = true;
  });

// Handle clicks on flavor cards
const flavorCards = document.querySelectorAll('.flavor-card');
flavorCards.forEach((card) => {
  card.addEventListener('click', (e) => {
    if (!isDragging) {
      const productHandle = card.getAttribute('data-product-handle');
      const productTitle = card.querySelector('.flavor-card-heading').textContent;
      
      // Navigate to the product page using the product handle
      if (productHandle) {
        window.location.href = `/products/${productHandle}`;
        console.log('Navigating to product:', productTitle);
      } else {
        console.error('Product handle not found for:', productTitle);
      }
    }
    isDragging = false;
  });
});

  // Reset isDragging on mouse up
  document.addEventListener('mouseup', () => {
    isDragging = false;
  });
});
// Subscriptions Test
document.addEventListener("DOMContentLoaded", function () {
  const oneTimeOption = document.querySelector("#one-time-purchase");
  const subscribeOption = document.querySelector("#skio-subscribe");
  const frequencyButtons = document.querySelectorAll("[data-skio='frequency']");
  const skioSubscriptionData = document.querySelector("#skio-subscription-data");
  const variantInput = document.querySelector("#selected-variant-id");
  const variantButtons = document.querySelectorAll(".quantity");

  function updateSubscriptionData() {
    if (subscribeOption.checked) {
      const selectedFrequency = document.querySelector(".delivery.active")?.dataset.frequency || "4"; // Default 4 weeks
      skioSubscriptionData.value = JSON.stringify({ frequency: selectedFrequency });
    } else {
      skioSubscriptionData.value = "";
    }
  }

  function updateVariantSelection() {
    const activeVariant = document.querySelector(".quantity.active");
    if (activeVariant) {
      variantInput.value = activeVariant.dataset.variantId; // Ensure this is a valid number
    }
  }

  // Handle purchase option change
  subscribeOption.addEventListener("change", updateSubscriptionData);
  oneTimeOption.addEventListener("change", updateSubscriptionData);

  // Handle delivery frequency selection
  frequencyButtons.forEach((button) => {
    button.addEventListener("click", function () {
      document.querySelectorAll(".delivery").forEach((btn) => btn.classList.remove("active"));
      this.classList.add("active");
      updateSubscriptionData();
    });
  });

  // Handle variant selection (if applicable)
  variantButtons.forEach((button) => {
    button.addEventListener("click", function () {
      document.querySelectorAll(".quantity").forEach((btn) => btn.classList.remove("active"));
      this.classList.add("active");
      updateVariantSelection();
    });
  });

  // Ensure the first variant is always selected on load
  if (variantButtons.length > 0) {
    updateVariantSelection();
  }
  
  // Set initial subscription data
  updateSubscriptionData();
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-review-header"] && !Shopify.designMode) return;
  try {
    

  document.addEventListener("DOMContentLoaded", function () {
    const cards = document.querySelectorAll(".custom-sub-review-carousel-card");
    const videos = document.querySelectorAll(".custom-video-review-carousel-video");

    function pauseAllOtherVideos(currentVideo) {
      videos.forEach((video) => {
        if (video !== currentVideo) {
          video.pause();
          const parentCard = video.closest(".custom-sub-review-carousel-card");
          const playBtn = parentCard?.querySelector(".play-btn");
          if (playBtn) playBtn.style.display = "block";
        }
      });
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (!entry.isIntersecting) {
            video.pause();
            const parentCard = video.closest(".custom-sub-review-carousel-card");
            const playBtn = parentCard?.querySelector(".play-btn");
            if (playBtn) playBtn.style.display = "block";
          }
        });
      },
      { threshold: 0.1 }
    );

    cards.forEach((card) => {
      const video = card.querySelector(".custom-video-review-carousel-video");
      const playBtn = card.querySelector(".play-btn");
      const volumeBtn = card.querySelector(".volume-btn");
      const volumeIcon = volumeBtn?.querySelector(".volume-icon");
      const muteIcon = volumeBtn?.querySelector(".mute-icon");

      if (!video) return;

      function toggleVideoPlay() {
        if (video.paused) {
          pauseAllOtherVideos(video);
          video.muted = false;
          video.play().then(() => {
            if (playBtn) playBtn.style.display = "none";
          }).catch((err) => {
            console.error("Video play failed:", err);
          });
        } else {
          video.pause();
          if (playBtn) playBtn.style.display = "block";
        }
      }

      video.addEventListener("click", (e) => {
        e.stopPropagation();
        toggleVideoPlay();
      });

      if (playBtn) {
        playBtn.addEventListener("click", (e) => {
          e.stopPropagation();
          toggleVideoPlay();
        });
      }

      video.addEventListener("ended", () => {
        if (playBtn) playBtn.style.display = "block";
      });

      if (volumeBtn) {
        volumeBtn.addEventListener("click", (e) => {
          e.stopPropagation();
          video.muted = !video.muted;
          if (volumeIcon && muteIcon) {
            volumeIcon.style.display = video.muted ? "none" : "block";
            muteIcon.style.display = video.muted ? "block" : "none";
          }
        });
      }

      observer.observe(video);
    });
  });



document.addEventListener("DOMContentLoaded", function () {
    const track = document.querySelector(".review-header-logo-carousel-track");
    const logos = track.innerHTML; 
    track.innerHTML += logos;
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-review-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    const productId = "{{ product.id }}"; 
    const apiKey = "pubkey-h1PPDjY5cY7uYdSLPag1Hy61c4mXa3"; 
    const storeUrl = "craftmix.myshopify.com"; 
    const apiUrl = `https://stamped.io/api/widget/reviews?store=${storeUrl}&productId=${productId}&apiKey=${apiKey}`;

    fetch(apiUrl)
      .then(response => response.json())
      .then(data => {
        const reviewsContainer = document.getElementById("custom-reviews");
        reviewsContainer.innerHTML = ""; // Clear existing content

        if (data.reviews && data.reviews.length > 0) {
          data.reviews.forEach(review => {
            const verifiedBadge = review.verified ? `
              <div class="verified">
                <img src="https://cdn.shopify.com/s/files/1/2340/1623/files/tick-icon.png?v=1739131445" alt="Verified">
                <p>Verified buyer</p>
              </div>` : '';

            const recommendedBadge = review.recommend ? `
              <div class="recommend">
                <img src="https://cdn.shopify.com/s/files/1/2340/1623/files/tick-icon.png?v=1739131445" alt="Recommended">
                <p>I recommend this product</p>
              </div>` : '';

            const reviewHtml = `
              <div class="product-review">
                <div class="product-review-client-details">
                  <h5 class="client-name">${review.author}</h5>
                  <div class="credentials">
                    ${verifiedBadge}
                    ${recommendedBadge}
                  </div>
                </div>
                <div class="product-review-client-review">
                  <div class="stars">${renderStars(review.rating)}</div>
                  <h5 class="review-title">${review.title}</h5>
                  <p class="review-text">${review.message}</p>
                </div>
              </div>
            `;
            reviewsContainer.innerHTML += reviewHtml;
          });
        } else {
          reviewsContainer.innerHTML = "<p>No reviews yet. Be the first to review this product!</p>";
        }
      })
      .catch(error => {
        console.error("Error fetching reviews:", error);
        document.getElementById("custom-reviews").innerHTML = "<p>Failed to load reviews.</p>";
      });

    // Helper function to render stars dynamically
    function renderStars(rating) {
      let starHtml = '';
      for (let i = 0; i < 5; i++) {
        if (i < rating) {
          starHtml += '<img src="https://cdn.shopify.com/s/files/1/2340/1623/files/star-filled.svg?v=123456789" alt="★">';
        } else {
          starHtml += '<img src="https://cdn.shopify.com/s/files/1/2340/1623/files/star-empty.svg?v=123456789" alt="☆">';
        }
      }
      return starHtml;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-sub-video-carousel"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const cards = document.querySelectorAll('.custom-sub-review-carousel-card');
  const videos = document.querySelectorAll('.custom-video-review-carousel-video');

  cards.forEach(card => {
    const video = card.querySelector('.custom-video-review-carousel-video');
    const playBtn = card.querySelector('.play-btn');
    const volumeBtn = card.querySelector('.volume-btn');
    const volumeIcon = volumeBtn.querySelector('.volume-icon');
    const muteIcon = volumeBtn.querySelector('.mute-icon');

    // Fade-in fix: Add 'ready' class once video is actually rendering a frame
    video.addEventListener('playing', () => {
      video.classList.add('ready');
    });

    // Play/Pause Button Click
    playBtn.addEventListener('click', () => {
      if (video.paused) {
        pauseAllVideos(video); // Ensure only one video plays
        video.play();
        playBtn.style.display = 'none';
      } else {
        video.pause();
        playBtn.style.display = 'block';
      }
    });

    // Video Click to Play/Pause
    video.addEventListener('click', () => {
      if (video.paused) {
        pauseAllVideos(video);
        video.play();
        playBtn.style.display = 'none';
      } else {
        video.pause();
        playBtn.style.display = 'block';
      }
    });

    // Reset Play Button when Video Ends
    video.addEventListener('ended', () => {
      playBtn.style.display = 'block';
    });

    // Volume Control Button
    volumeBtn.addEventListener('click', () => {
      if (video.muted) {
        video.muted = false;
        volumeIcon.style.display = 'block';
        muteIcon.style.display = 'none';
      } else {
        video.muted = true;
        volumeIcon.style.display = 'none';
        muteIcon.style.display = 'block';
      }
    });
  });

  // Function to Pause All Other Videos
  function pauseAllVideos(currentVideo) {
    videos.forEach(video => {
      if (video !== currentVideo) {
        video.pause();
      }
    });
  }

  // Pause Videos When They Go Out of View
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) {
        entry.target.pause();
      }
    });
  }, { threshold: 0.1 });

  videos.forEach(video => observer.observe(video));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-account"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const faqs = document.querySelectorAll('.account-faq');

  faqs.forEach(faq => {
    const answer = faq.querySelector('.faq-answer');

    // Set initial height if active
    if (faq.classList.contains('active') && answer) {
      answer.style.height = answer.scrollHeight + 'px';
    }

    faq.addEventListener('click', () => {
      const isActive = faq.classList.contains('active');

      // Close all other FAQs in this group
      faqs.forEach(item => {
        if (item !== faq) {
          item.classList.remove('active');
          const itemAnswer = item.querySelector('.faq-answer');
          if (itemAnswer) itemAnswer.style.height = '0px';
        }
      });

      // Toggle clicked FAQ
      faq.classList.toggle('active');
      if (!isActive && answer) {
        answer.style.height = answer.scrollHeight + 'px';
      } else if (isActive && answer) {
        answer.style.height = '0px';
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-ingredient"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const faqs = document.querySelectorAll('.ingredient-faq');

  faqs.forEach(faq => {
    const answer = faq.querySelector('.faq-answer');

    // Set initial height if active
    if (faq.classList.contains('active') && answer) {
      answer.style.height = answer.scrollHeight + 'px';
    }

    faq.addEventListener('click', () => {
      const isActive = faq.classList.contains('active');

      // Close all other FAQs in this group
      faqs.forEach(item => {
        if (item !== faq) {
          item.classList.remove('active');
          const itemAnswer = item.querySelector('.faq-answer');
          if (itemAnswer) itemAnswer.style.height = '0px';
        }
      });

      // Toggle clicked FAQ
      faq.classList.toggle('active');
      if (!isActive && answer) {
        answer.style.height = answer.scrollHeight + 'px';
      } else if (isActive && answer) {
        answer.style.height = '0px';
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-product"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const faqs = document.querySelectorAll('.product-faq');

  faqs.forEach(faq => {
    const answer = faq.querySelector('.faq-answer');

    // Set initial height if active
    if (faq.classList.contains('active') && answer) {
      answer.style.height = answer.scrollHeight + 'px';
    }

    faq.addEventListener('click', () => {
      const isActive = faq.classList.contains('active');

      // Close all other FAQs in this group
      faqs.forEach(item => {
        if (item !== faq) {
          item.classList.remove('active');
          const itemAnswer = item.querySelector('.faq-answer');
          if (itemAnswer) itemAnswer.style.height = '0px';
        }
      });

      // Toggle clicked FAQ
      faq.classList.toggle('active');
      if (!isActive && answer) {
        answer.style.height = answer.scrollHeight + 'px';
      } else if (isActive && answer) {
        answer.style.height = '0px';
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-shipping"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const faqs = document.querySelectorAll('.shipping-faq');

  faqs.forEach(faq => {
    const answer = faq.querySelector('.faq-answer');

    // Set initial height if active
    if (faq.classList.contains('active') && answer) {
      answer.style.height = answer.scrollHeight + 'px';
    }

    faq.addEventListener('click', () => {
      const isActive = faq.classList.contains('active');

      // Close all other FAQs in this group
      faqs.forEach(item => {
        if (item !== faq) {
          item.classList.remove('active');
          const itemAnswer = item.querySelector('.faq-answer');
          if (itemAnswer) itemAnswer.style.height = '0px';
        }
      });

      // Toggle clicked FAQ
      faq.classList.toggle('active');
      if (!isActive && answer) {
        answer.style.height = answer.scrollHeight + 'px';
      } else if (isActive && answer) {
        answer.style.height = '0px';
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
   document.addEventListener("DOMContentLoaded", function () {
    const modal = document.getElementById("custom-contact-modal");
    const openButtons = document.querySelectorAll("a[href='#custom-contact-modal']"); // Includes footer menu link
    const closeButton = document.querySelector(".close-modal");
    const body = document.body;
    const successMessage = document.getElementById("success-message");

    // Ensure modal is hidden when page loads
    if (modal) {
        modal.style.display = "none";
    }

    openButtons.forEach(button => {
        button.addEventListener("click", function (event) {
            event.preventDefault();
            if (modal) {
                modal.style.display = "flex";
                body.classList.add("modal-open"); // Prevent scrolling
            }
        });
    });

    if (closeButton) {
        closeButton.addEventListener("click", function () {
            if (modal) {
                modal.style.display = "none";
                body.classList.remove("modal-open"); // Restore scrolling
            }
        });
    }

    window.addEventListener("click", function (event) {
        if (event.target === modal) {
            modal.style.display = "none";
            body.classList.remove("modal-open"); // Restore scrolling
        }
    });
 
    // Check if the URL contains ?contact_posted=true to show success message
    // const urlParams = new URLSearchParams(window.location.search);
    // if (urlParams.has("contact_posted")) {
    //     successMessage.style.display = "block";
    //     setTimeout(() => {
    //         successMessage.style.display = "none";
    //     }, 3000); 
    // }
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-account"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
       const tabs = document.querySelectorAll('[data-tab-target]')
       const tabsContent = document.querySelectorAll('[data-tab-content]')
        
    
      tabs.forEach(tab => {
        tab.addEventListener('click', () => {
          const target = document.querySelector(tab.dataset.tabTarget)
          tabsContent.forEach(tabContent => {
            tabContent.classList.remove('active')
          })

           tabs.forEach(tab => {
            tab.classList.remove('active')
          })
          
          tab.classList.add('active')
          target.classList.add('active')
        })
      })

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid-2025"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function() {
  document.body.classList.add('page-loaded');

  const addToCartButtons = document.querySelectorAll('.product-card-add-btn');
  // console.log(`Found ${addToCartButtons.length} Add to Cart buttons`);

  document.body.addEventListener('click', function(event) {
    const button = event.target.closest('.product-card-add-btn');
    if (button) {
      event.preventDefault();

     let variantId = button.getAttribute('data-product-id');

      if (variantId) {
        addToCart(variantId, 1);
      }
    }
  });

  document.body.addEventListener('change', function(event) {
    if (event.target.matches('select[name="product-variant-size"]')) {
      const select = event.target;
      const productCard = select.closest('.product-card');
      const selectedOption = select.options[select.selectedIndex];
      const variantPrice = selectedOption.getAttribute('data-price');
      const variantid = selectedOption.getAttribute('data-id');
      const priceElement = productCard.querySelector('.variant-price');

      if (priceElement) {
        priceElement.textContent = formatMoney(variantPrice);
        priceElement.setAttribute('data-product-id', variantid);
      }
    }
  });

  // Custom Variant Dropdown Handler
  document.querySelectorAll('.custom-variant-trigger').forEach(trigger => {
    const dropdownId = trigger.getAttribute('data-dropdown-id');
    const dropdown = document.getElementById(dropdownId);
    const selectedText = trigger.querySelector('.selected-variant');

    if (!dropdown || !selectedText) return;

    trigger.addEventListener('click', (e) => {
    e.stopPropagation();

    // Close all other dropdowns
    document.querySelectorAll('.variant-options-container').forEach(d => {
      if (d !== dropdown) d.style.display = 'none';
    });

    // Toggle visibility
    if (dropdown.style.display === 'block') {
      dropdown.style.display = 'none';
      dropdown.classList.remove('below');
    } else {
      dropdown.classList.remove('above'); // ensure 'above' is removed
      dropdown.classList.add('below'); // always apply 'below'
      dropdown.style.display = 'block';
    }
  });

    dropdown.querySelectorAll('.variant-option').forEach(option => {
      option.addEventListener('click', () => {
        const variantId = option.dataset.id;
        const variantPrice = option.dataset.price;
        const title = option.textContent;

        selectedText.textContent = title;
        dropdown.style.display = 'none';

        const productCard = trigger.closest('.product-card');
        const addBtn = productCard.querySelector('.product-card-add-btn');
        const priceEl = productCard.querySelector('.variant-price');

        // console.log('Updating button with variantId:', variantId);
        
        if (addBtn) addBtn.setAttribute('data-product-id', variantId);
        if (priceEl){priceEl.textContent = formatMoney(variantPrice); priceEl.setAttribute('data-product-id', variantId); } 
      });
    });
  });

  // Close dropdowns when clicking outside
  document.addEventListener('click', () => {
    document.querySelectorAll('.variant-options-container').forEach(dropdown => {
      dropdown.style.display = 'none';
    });
  });

  // Init filters
  initProductFilter();

  function initProductFilter() {
    const filterLinks = document.querySelectorAll('.filter-link');
    const productCards = document.querySelectorAll('.product-card-container');
    const pinkLeaf = document.querySelector('.mint_pink-bg');
    const blueberry = document.querySelector('.blueberry-bg');

    filterLinks.forEach(link => {
      link.addEventListener('click', function(event) {
  
        const selectedTag = this.getAttribute('data-tag');

        // Update active state
        filterLinks.forEach(l => {
          l.classList.remove('active');
          l.removeAttribute('aria-pressed');
        });
        this.classList.add('active');
        this.setAttribute('aria-pressed', 'true');
        
        // Show/hide cards
        productCards.forEach(card => {
          const cardTags = card.getAttribute('data-tags').split(',');
          const show = selectedTag === 'all' || cardTags.includes(selectedTag);
          card.style.display = show ? 'block' : 'none';

          // Reset SVG (if needed)
          if (show) {
            const svg = card.querySelector('svg');
            if (svg) {
              const clone = svg.cloneNode(true);
              svg.replaceWith(clone);
            }
          }
        });

        pinkLeaf.style.display = selectedTag === 'all' ? 'block' : 'none';
        blueberry.style.display = selectedTag === 'all' ? 'block' : 'none';
      });
    });
  }

  function addToCart(variantId, quantity) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status && data.status !== 200) {
        alert(`Error: ${data.message || 'Could not add to cart'}`);
      } else {
        console.log('Product added to cart:', data);
      }
    })
    .catch(error => {
      console.error('Error adding product to cart:', error);
    });
  }

  function formatMoney(cents) {
    const dollars = (cents / 100).toFixed(2);
    return `$${dollars}`;
  }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-flavor-carousel"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const addToCartButtons = document.querySelectorAll('.flavor-carousel-product-card-add-btn');

  // Toggle dropdown logic
  document.querySelectorAll('.custom-variant-trigger').forEach(trigger => {
    const dropdownId = trigger.getAttribute('data-dropdown-id');
    const dropdown = document.getElementById(dropdownId);
    const selectedText = trigger.querySelector('.selected-variant');

    if (!dropdown || !selectedText) return;

    trigger.addEventListener('click', (e) => {
      e.stopPropagation();

      // Hide any other open dropdowns
      document.querySelectorAll('.variant-options-container').forEach(d => {
        if (d !== dropdown) {
          d.style.display = 'none';
        }
      });

      // Show this dropdown
      dropdown.style.display = dropdown.style.display === 'block' ? 'none' : 'block';
    });

    // Variant selection inside dropdown
    dropdown.querySelectorAll('.variant-option').forEach(option => {
      option.addEventListener('click', () => {
        const variantId = option.dataset.id;
        const variantPrice = option.dataset.price;
        const title = option.textContent;

        selectedText.textContent = title;
        dropdown.style.display = 'none';

        const productCard = trigger.closest('.flavor-carousel-product-card');
        const addBtn = productCard.querySelector('.flavor-carousel-product-card-add-btn');
        const priceEl = productCard.querySelector('.flavor-carousel-variant-price');

        if (addBtn) addBtn.setAttribute('data-product-id', variantId);
        if (priceEl){priceEl.textContent = formatMoney(variantPrice); priceEl.setAttribute('data-product-id', variantId); } 
      });
    });
  });

  // Close dropdown if clicked outside
  document.addEventListener('click', () => {
    document.querySelectorAll('.variant-options-container').forEach(dropdown => {
      dropdown.style.display = 'none';
    });
  });

  // Add to cart functionality
  addToCartButtons.forEach(button => {
    button.addEventListener('click', function(event) {
      event.preventDefault();
      const variantId = this.getAttribute('data-product-id');
      const quantity = 1;

      addToCart(variantId, quantity);
    });
  });

  function addToCart(variantId, quantity) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
    })
    .then(response => response.json())
    .then(data => {
      console.log('Product added to cart:', data);
    })
    .catch(error => {
      console.error('Error adding product to cart:', error);
    });
  }

  function formatMoney(cents) {
    const dollars = (cents / 100).toFixed(2);
    return `$${dollars}`;
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-nutrition-section"] && !Shopify.designMode) return;
  try {
    
// // Flavor Bar
document.addEventListener('DOMContentLoaded', function () {
  const flavorBars = document.querySelectorAll('.flavor-bar');

  flavorBars.forEach(flavorBar => {
    let sweetnessPercentage = parseInt(flavorBar.dataset.flavor, 10) || 0;

    // Clamp to 0–100
    sweetnessPercentage = Math.max(0, Math.min(100, sweetnessPercentage));

    setFlavorRange(flavorBar, sweetnessPercentage);
  });
});

function setFlavorRange(flavorBar, percentage) {
  const fillElement = flavorBar.querySelector('.flavor-range-fill');
  const iconElement = flavorBar.querySelector('.flavor-icon');
  
  if (fillElement && iconElement) {
    fillElement.style.width = `${percentage}%`;
    iconElement.style.left = `${percentage}%`;
  }
}

// // Nutrition Card 
// Hide all expandable rows 
document.querySelectorAll('.nutrition-fact-card').forEach(card => {
  card.querySelectorAll('.expandable').forEach(row => {
    row.style.display = 'none';
  });
});

// Add click listener to each expand button
document.querySelectorAll('.expand-btn').forEach(button => {
  button.addEventListener('click', function () {
    const card = button.closest('.nutrition-fact-card');
    const expandableRows = card.querySelectorAll('.expandable');
    const isOpen = expandableRows[0].style.display === 'table-row';

    expandableRows.forEach(row => {
      row.style.display = isOpen ? 'none' : 'table-row';
    });

    button.textContent = isOpen ? 'See All Nutrition Facts' : 'Collapse Nutrition Facts';
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-video-carousel"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
    const cards = document.querySelectorAll('.custom-review-carousel-card');

    // Pause all other videos when one plays
    function pauseAllOtherVideos(currentVideo) {
        const videos = document.querySelectorAll('.custom-video-review-carousel-video');

        videos.forEach(video => {
            if (video !== currentVideo) {
                video.pause();
                const parentCard = video.closest('.custom-review-carousel-card');
                const playBtn = parentCard.querySelector('.play-btn');
                if (playBtn) {
                    playBtn.style.display = 'block';
                }
            }
        });
    }

    // Pause videos when they leave the viewport
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            const video = entry.target;

            if (!entry.isIntersecting) {
                video.pause();
                const parentCard = video.closest('.custom-review-carousel-card');
                const playBtn = parentCard.querySelector('.play-btn');
                if (playBtn) {
                    playBtn.style.display = 'block';
                }
            }
        });
    }, { threshold: 0.1 }); // Adjust threshold if needed

    // Apply behavior to each video card
    cards.forEach(card => {
        const video = card.querySelector('.custom-video-review-carousel-video');
        const playBtn = card.querySelector('.play-btn');
        const volumeBtn = card.querySelector('.volume-btn');
        const volumeIcon = volumeBtn.querySelector('.volume-icon');
        const muteIcon = volumeBtn.querySelector('.mute-icon');

        function toggleVideoPlay() {
            const isPlaying = !video.paused;

            if (isPlaying) {
                video.pause();
                playBtn.style.display = 'block';
            } else {
                pauseAllOtherVideos(video);
                video.muted = false;
                video.play().then(() => {
                    playBtn.style.display = 'none';
                }).catch(err => {
                    console.error('Video play failed:', err);
                });
            }
        }

        video.addEventListener('click', (e) => {
            e.stopPropagation();
            toggleVideoPlay();
        });

        playBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            toggleVideoPlay();
        });

        video.addEventListener('ended', () => {
          video.pause();
          video.currentTime = 0;
          video.load(); // This resets and shows the poster
          playBtn.style.display = 'block';
        });

        volumeBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            if (video.muted) {
                video.muted = false;
                volumeIcon.style.display = 'block';
                muteIcon.style.display = 'none';
            } else {
                video.muted = true;
                volumeIcon.style.display = 'none';
                muteIcon.style.display = 'block';
            }
        });

        // Start observing the video for scroll visibility
        observer.observe(video);
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-flavor-carousel"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const addToCartButtons = document.querySelectorAll('.flavor-carousel-product-card-add-btn');

  // Toggle dropdown logic
  document.querySelectorAll('.custom-variant-trigger').forEach(trigger => {
    const dropdownId = trigger.getAttribute('data-dropdown-id');
    const dropdown = document.getElementById(dropdownId);
    const selectedText = trigger.querySelector('.selected-variant');

    if (!dropdown || !selectedText) return;

    trigger.addEventListener('click', (e) => {
      e.stopPropagation();

      // Hide any other open dropdowns
      document.querySelectorAll('.variant-options-container').forEach(d => {
        if (d !== dropdown) {
          d.style.display = 'none';
        }
      });

      // Show this dropdown
      dropdown.style.display = dropdown.style.display === 'block' ? 'none' : 'block';
    });

    // Variant selection inside dropdown
    dropdown.querySelectorAll('.variant-option').forEach(option => {
      option.addEventListener('click', () => {
        const variantId = option.dataset.id;
        const variantPrice = option.dataset.price;
        const title = option.textContent;

        selectedText.textContent = title;
        dropdown.style.display = 'none';

        const productCard = trigger.closest('.flavor-carousel-product-card');
        const addBtn = productCard.querySelector('.flavor-carousel-product-card-add-btn');
        const priceEl = productCard.querySelector('.flavor-carousel-variant-price');

        if (addBtn) addBtn.setAttribute('data-product-id', variantId);
        if (priceEl){priceEl.textContent = formatMoney(variantPrice); priceEl.setAttribute('data-product-id', variantId); } 
      });
    });
  });

  // Close dropdown if clicked outside
  document.addEventListener('click', () => {
    document.querySelectorAll('.variant-options-container').forEach(dropdown => {
      dropdown.style.display = 'none';
    });
  });

  // Add to cart functionality
  addToCartButtons.forEach(button => {
    button.addEventListener('click', function(event) {
      event.preventDefault();
      const variantId = this.getAttribute('data-product-id');
      const quantity = 1;

      addToCart(variantId, quantity);
    });
  });

  function addToCart(variantId, quantity) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
    })
    .then(response => response.json())
    .then(data => {
      console.log('Product added to cart:', data);
    })
    .catch(error => {
      console.error('Error adding product to cart:', error);
    });
  }

  function formatMoney(cents) {
    const dollars = (cents / 100).toFixed(2);
    return `$${dollars}`;
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscribe-faq"] && !Shopify.designMode) return;
  try {
    
 
document.addEventListener('DOMContentLoaded', function () {
  const faqs = document.querySelectorAll('.faq');

  faqs.forEach(faq => {
    const question = faq.querySelector('.question');
    const answer = faq.querySelector('.answer');

    question.addEventListener('click', () => {
      faq.classList.toggle('active');

      if (faq.classList.contains('active')) {
        answer.style.maxHeight = answer.scrollHeight + "px";
      } else {
        answer.style.maxHeight = null;
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v2-pdp-faq-section"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function () {
  const faqs = document.querySelectorAll('.faq');

  faqs.forEach(faq => {
    const question = faq.querySelector('.question');
    const answer = faq.querySelector('.answer');

    question.addEventListener('click', () => {
      faqs.forEach(otherFaq => {
        const otherAnswer = otherFaq.querySelector('.answer');
        if (otherFaq !== faq) {
          otherFaq.classList.remove('faq-active');
          if (otherAnswer) otherAnswer.style.maxHeight = null;
        }
      });

      const isActive = faq.classList.toggle('faq-active');

      if (isActive) {
        answer.style.maxHeight = answer.scrollHeight + 'px';
      } else {
        answer.style.maxHeight = null;
      }
    });
  });

  // Initialize open height for the default open one (faq-active)
  const activeAnswer = document.querySelector('.faq-active .answer');
  if (activeAnswer) {
    activeAnswer.style.maxHeight = activeAnswer.scrollHeight + 'px';
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["what-our-fans-say-subscription"] && !Shopify.designMode) return;
  try {
    
  
          document.addEventListener('DOMContentLoaded', () => {
    const cards = document.querySelectorAll('.custom-video-review-carousel-card');
    const videos = document.querySelectorAll('.custom-video-review-carousel-video');

    cards.forEach(card => {
        const video = card.querySelector('.custom-video-review-carousel-video');
        const playBtn = card.querySelector('.play-btn');
        // const playIcon = playBtn.querySelector('.play-icon');
        const volumeBtn = card.querySelector('.volume-btn');
        const volumeIcon = volumeBtn.querySelector('.volume-icon');
        const muteIcon = volumeBtn.querySelector('.mute-icon');

        // Play/Pause Button Click
        playBtn.addEventListener('click', () => {
            if (video.paused) {
                pauseAllVideos(video); // Ensure only one video plays
                video.play();
                // playIcon.style.display = 'none';
                playBtn.style.display = 'none';
            } else {
                video.pause();
                // playIcon.style.display = 'block';
                playBtn.style.display = 'block';
            }
        });

        // Video Click to Play/Pause
        video.addEventListener('click', () => {
            if (video.paused) {
                pauseAllVideos(video);
                video.play();
                // playIcon.style.display = 'none';
                playButton.style.display = 'none';
            } else {
                video.pause();
                playButton.style.display = 'block';
            }
        });

        // Reset Play Button when Video Ends
        video.addEventListener('ended', () => {
            playBtn.style.display = 'block';
            // playIcon.style.display = 'block';
        });

        // Volume Control Button
        volumeBtn.addEventListener('click', () => {
            if (video.muted) {
                video.muted = false;
                volumeIcon.style.display = 'block';
                muteIcon.style.display = 'none';
            } else {
                video.muted = true;
                volumeIcon.style.display = 'none';
                muteIcon.style.display = 'block';
            }
        });
    });

    // Function to Pause All Other Videos
    function pauseAllVideos(currentVideo) {
        videos.forEach(video => {
            if (video !== currentVideo) {
                video.pause();
            }
        });
    }

    // Pause Videos When They Go Out of View
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (!entry.isIntersecting) {
                entry.target.pause();
            }
        });
    }, { threshold: 0.1 });

    videos.forEach(video => observer.observe(video));
});      


  } catch(e) { console.error(e); }
})();
})();
